export enum VideoStatus{
    ONLINE="Online",
    OFFLINE="OffLine",
    CONNECTING="Connecting",
    CONNECTED="Local Connected",
    ROOM_DISCONNECTED="Room Disconnected",
}